import { DatePicker } from 'antd';
import momentGenerateConfig from '@rc-component/picker/generate/moment';
import type { Moment } from 'moment';

export const MomentDatePicker = DatePicker.generatePicker<Moment>(momentGenerateConfig);
